import { render, staticRenderFns } from "./manageExceptUser.vue?vue&type=template&id=127c9b9a&scoped=true&"
import script from "./manageExceptUser.vue?vue&type=script&lang=js&"
export * from "./manageExceptUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c9b9a",
  null
  
)

export default component.exports